import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Aplica cambios parciales conservando el tipo completo.
 *
 * `{ ...base, ...changes }` con un `Partial` ensancha cada campo a
 * `| undefined`, porque TypeScript no puede descartar que venga una clave
 * puesta explícitamente en `undefined`. Acá se descartan de verdad, así que el
 * tipo de retorno es honesto y no una aserción.
 */
export function merge<T extends object>(base: T, changes: Partial<NoInfer<T>>): T {
  const result = { ...base };
  for (const [key, value] of Object.entries(changes)) {
    if (value !== undefined) {
      (result as Record<string, unknown>)[key] = value;
    }
  }
  return result;
}
